exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info[data-v-7b969739]{padding-top:6px;font-family:Open Sans,sans-serif}.info__title[data-v-7b969739]{margin-bottom:10px;color:#de1010;font-size:14px;font-weight:400;z-index:1;position:relative}.info__title_confirmed[data-v-7b969739]{margin-bottom:0;color:#77b97e}.info__message[data-v-7b969739]{font-size:10px;line-height:1.3;color:#464646}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b969739","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/settings/components/info/Info.vue
// module id = 40b5103dd91cee42c8ad
// module chunks = 0